"use client";

import { LogOut, ShieldAlert } from "lucide-react";

import { Button } from "./ui/button";

// Shared 403 page. Admin apps register `{ path: "/forbidden", element: <AdminForbiddenPage /> }`
// from `@trillion/auth` (outside the AdminShell route) — it's where `useRequireProductRole`'s redirect
// lands when a signed-in user lacks the product admin role. `AdminForbiddenPage` wraps this component
// and passes `onLogout` to wire the escape hatch; this base stays router/auth-agnostic.

export interface ForbiddenPageProps {
  message?: string;
  /** When provided, renders a "Log out" action that calls this. Wired by `@trillion/auth`'s `AdminForbiddenPage`. */
  onLogout?: () => void;
}

export function ForbiddenPage({ message, onLogout }: ForbiddenPageProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <div className="rounded-full bg-destructive/10 p-3">
        <ShieldAlert className="size-6 text-destructive" />
      </div>
      <h1 className="text-xl font-semibold">Access denied</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {message ??
          "You don't have permission to view this page. If you think this is a mistake, contact an administrator."}
      </p>
      {onLogout && (
        <Button variant="outline" onClick={onLogout}>
          <LogOut className="mr-2 size-4" />
          Log out
        </Button>
      )}
    </div>
  );
}
